module.exports = __webpack_public_path__ + "img/tab-scroll-right-arrow.5460e12f.svg";